
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/breeds/[species]/[breed]",
      function () {
        return require("private-next-pages/breeds/[species]/[breed]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/breeds/[species]/[breed]"])
      });
    }
  